module.exports = __webpack_public_path__ + "img/ad-contact-md.1362d035.jpg";